import { getStaticAssetComponents } from './get-static-asset-components.js'
export function getStaticUiComponents(): string[] {
  return getStaticAssetComponents('ui')
}
